import React, { useEffect, useState } from "react";
import { CheckBox } from "./../../components/checkbox/checkbox";
import { Label } from "./../../components/checkbox/label";
import Question from "./../../components/question/question";
import { Radio } from "./../../components/radio_buutons/radio";
import { selectQuestionCounterOrCharacter } from "../quiz/QuizRunner.helpers";
import PropTypes from "prop-types";
import { ShowSequence } from "../quiz/QuizRunner.helpers";
import { CorrectAnswer } from "../../components/answers/correct_answer";
import { WrongAnswer } from "../../components/answers/wrong_answer";
import ReactHtmlParser from "react-html-parser";
import { isInUserSelectedAnswers } from "../quiz/QuizRunner.helpers";
import { size, includes } from "lodash";
import { DragAndDropRunner } from "../quiz/DragAndDropRunner";
import { InputMultiSelectTypeQuestion } from "../quiz/InputMultiSelectTypeQuestion";
import { InputTypeQuestion } from "../quiz/InputTypeQuestion";
import { exerciseType } from "../../components/constants/constants";
import { handleAnswersInput } from "../../components/edit_quiz_helper/EditQuizHelper.jsx";
import { type } from "../quiz/QuizRunner";
import { GenaiUrl, CreateQuizUrl } from "../../libs/env";
import ContentLoader from 'react-content-loader';

export const ShowExerciseQuestions = React.memo(
  ({
    questions,
    onAnswer,
    task_type,
    currentPage,
    isReview,
    answer,
    status,
    exercise_id,
    section_id,
    page_id,
    data,
    onUpdate,
    EndGptResponse,
    Qblinker,
    IsGenerating,
  }) => {
    let inputFiledLength = [];

    let checkflag = false;
    const [currentQuestion, setCurrentQuestion] = useState(currentPage);

    const [Questionedit, setQuestionedit] = useState(false);

    const [OptIndex, setOptIndex] = useState(0);
    useEffect(() => {
      const intervalId = setInterval(() => {
        setOptIndex((prevIndex) => prevIndex + 1);
      }, 100); // Update the index every 100 milliseconds

      return () => clearInterval(intervalId); // Clear the interval on unmount
    }, []);

    useEffect(() => {
      setCurrentQuestion(currentPage);
    }, [currentPage]);

    let isShowNumbering = size(questions) > 1;
    let fieldNumber,
      fieldlenght = 0;

    return (
      <div>
        <div className="col-12">
          {Qblinker ? <span className="blinking-cursor"></span> : null}
          {questions &&
            data?.prompt_content?.isMounted &&
            data?.html_content?.isMounted &&
            questions.map((question, qai) => {
              if (
                isReview ||
                status === null ||
                parseInt(currentQuestion) === parseInt(question.page)
              ) {
                question.prompt_content.replace(
                  /\[\[[^\]]*\]\]\*([\d]+)/g,
                  function replacer(matched) {
                    matched.replace(/\[\[[^\]]*\]\]/g, function replace(match) {
                      fieldNumber = match.match(/\d+/);
                    });
                    matched.replace(/\*([\d]+)/g, function replacer(matched) {
                      fieldlenght = matched.match(/\d+/);
                    });
                    inputFiledLength.push({
                      questionNumber: question.id,
                      fieldNumber: fieldNumber[0],
                      fieldlenght: fieldlenght[0],
                    });
                  }
                );
                const trimedString = question.prompt_content.trim();
                const converted = trimedString.replace(
                  /\[\[([^\]]*)\]\](?: *\[(.*?)\])?/g,
                  function replacer(matched, dataID, placeholderText) {
                    return question.type === "FillInBlank"
                      ? `<input type="text" className="form-control-sm" placeholder="${placeholderText || ""}" data-id ="${dataID}"  class="inline"/>`
                      : question.type === "DragAndDrop"
                      ? `<span data-type="${
                          question.type
                        }" type="text" className="form-control-sm" data-id ="${matched.match(
                          /\d+/
                        )}"  ></span>`
                      : `<select data-id ="${matched.match(
                          /\d+/
                        )}"  class="inline"></select>`;
                  }
                );

                return (
                  <div>
                    {includes(question.type, "Drag") ? (
                      <DragAndDropRunner
                        exercise_id={exercise_id}
                        data_possible_type={data.type}
                        section_id={section_id}
                        page_id={page_id}
                        question={question}
                        converted={converted}
                        isShowNumbering={isShowNumbering}
                        qai={qai}
                        answer={answer}
                        isReview={isReview}
                        Questionedit={Questionedit}
                        data={data}
                      />
                    ) : (
                      <div className="mb-3" key={qai}>
                        <div className="icon-wrapper">
                          <Question
                            // counterClass={getCounterCls(converted)}
                            Questionedit={Questionedit}
                            setQuestionedit={setQuestionedit}
                            onUpdate={onUpdate}
                            qai={qai}
                            data={data}
                            EndGptResponse={EndGptResponse}
                            showNumbers={isShowNumbering}
                            DisableQuestionNumbering={
                              question.disable_question_numbering
                            }
                            counterClass="me-2"
                            counter={qai + 1 + "."}
                            alignement={question.question_alignement}
                            title={ReactHtmlParser(
                              converted.replace(/\*([\d]+)/g, ""),
                              {
                                transform: (node) => {
                                  if (node.name === "input") {
                                    return (
                                      <InputTypeQuestion
                                        isReview={isReview}
                                        onAnswer={onAnswer}
                                        question={question}
                                        exercise_id={exercise_id}
                                        section_id={section_id}
                                        page_id={page_id}
                                        inputFiledLength={inputFiledLength}
                                        node={node}
                                        data={data}
                                        answer={answer}
                                      />
                                    );
                                  } else if (node.name === "select") {
                                    return (
                                      <InputMultiSelectTypeQuestion
                                        isReview={isReview}
                                        onAnswer={onAnswer}
                                        question={question}
                                        exercise_id={exercise_id}
                                        section_id={section_id}
                                        page_id={page_id}
                                        node={node}
                                        data={data}
                                        answer={answer}
                                      />
                                    );
                                  }
                                },
                              }
                            )}
                          />
                          {question.type === "RadioBox" ||
                          question.type === "CheckBox" ? (
                            <div
                              data-tc={
                                question.type === "CheckBox"
                                  ? "Checkbox-question"
                                  : "Radiobox-question"
                              }
                              className={
                                question.question_horizontal_display
                                  ? "row d-inline-flex  align-items-end "
                                  : null
                              }
                            >
                              {question.possible_answers.map(
                                (possible_answers, pai) => (
                                  <div
                                    className={
                                      question.type === "RadioBox" ||
                                      question.type === "CheckBox"
                                        ? question.question_horizontal_display
                                          ? "d-flex mt-2 ms-3 inline-grid col"
                                          : "d-flex mt-2 ms-3"
                                        : null
                                    }
                                  >
                                    <label for={possible_answers.id}>
                                      {possible_answers.image &&
                                      question.question_horizontal_display ? (
                                        <img
                                          src={possible_answers.image}
                                          height={possible_answers.image_height}
                                          px
                                          alt="img"
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </label>
                                    <div
                                      className={
                                        question.type === "RadioBox" ||
                                        question.type === "CheckBox"
                                          ? "form-check d-flex align-items-center form-check-inline custom-form-check"
                                          : null
                                      }
                                    >
                                      {data.type === type.Assessment
                                        ? answer.forEach((answ) => {
                                            if (
                                              answ.section_id === section_id &&
                                              answ.exercise_id ===
                                                exercise_id &&
                                              answ.page_id === page_id
                                            ) {
                                              answ.answers.forEach((ans) => {
                                                if (
                                                  ans.question_id ===
                                                  question.id
                                                ) {
                                                  ans.selected_answers.forEach(
                                                    (sel_ans) => {
                                                      if (
                                                        possible_answers.id ===
                                                        sel_ans["id"]
                                                      ) {
                                                        checkflag = true;
                                                      }
                                                    }
                                                  );
                                                }
                                              });
                                            }
                                          })
                                        : answer.forEach((ans) => {
                                            if (
                                              ans.question_id === question.id
                                            ) {
                                              ans.selected_answers.forEach(
                                                (sel_ans) => {
                                                  if (
                                                    possible_answers.id ===
                                                    sel_ans["id"]
                                                  ) {
                                                    checkflag = true;
                                                  }
                                                }
                                              );
                                            }
                                          })}

                                      <span className="text-uppercase">
                                        <b>
                                        {question.show_sequence !==
                                        ShowSequence.NoSequenceIndicator
                                          ? selectQuestionCounterOrCharacter({
                                              index: pai,
                                              show_abc_sequence:
                                                question.show_sequence,
                                            }) + "."
                                          : null}
                                        </b>
                                      </span>
                                      {question.type === "CheckBox" ? (
                                        <CheckBox
                                          key={question.id}
                                          defaultChecked={
                                            checkflag === true
                                              ? checkflag
                                              : null
                                          }
                                          index={
                                            selectQuestionCounterOrCharacter({
                                              index: pai,
                                              show_abc_sequence:
                                                question.show_abc_sequence,
                                            }) + "."
                                          }
                                          data-question-id={question.id}
                                          data-question-type={question.type}
                                          onClick={onAnswer}
                                          value={possible_answers.id}
                                          id={possible_answers.id}
                                          data-exercise-id={exercise_id}
                                          data-section-id={section_id}
                                          data-page-id={page_id}
                                          name={`answers[${qai}].selected_answers[${pai}]`}
                                          checked={
                                            isReview
                                              ? isInUserSelectedAnswers(
                                                  question,
                                                  possible_answers.id
                                                )
                                              : null
                                          }
                                          className={
                                            isReview &&
                                            !isInUserSelectedAnswers(
                                              question,
                                              possible_answers.id
                                            ) &&
                                            possible_answers.is_correct
                                              ? "form-check-input correct_answers ms-2"
                                              : "form-check-input ms-2"
                                          }
                                        />
                                      ) : question.type === "RadioBox" ? (
                                        <Radio
                                          key={question.id}
                                          defaultChecked={
                                            checkflag === true
                                              ? checkflag
                                              : null
                                          }
                                          index={
                                            selectQuestionCounterOrCharacter({
                                              index: pai,
                                              show_abc_sequence:
                                                question.show_abc_sequence,
                                            }) + "."
                                          }
                                          data-question-id={question.id}
                                          data-question-type={question.type}
                                          data-exercise-id={exercise_id}
                                          data-section-id={section_id}
                                          data-page-id={page_id}
                                          onClick={onAnswer}
                                          value={possible_answers.id}
                                          id={possible_answers.id}
                                          name={`answers[${qai}].selected_answers`}
                                          checked={
                                            isReview
                                              ? isInUserSelectedAnswers(
                                                  question,
                                                  possible_answers.id
                                                )
                                              : null
                                          }
                                          className={
                                            isReview &&
                                            !isInUserSelectedAnswers(
                                              question,
                                              possible_answers.id
                                            ) &&
                                            possible_answers.is_correct
                                              ? "form-check-input correct_answers ms-2"
                                              : "form-check-input ms-2"
                                          }
                                        />
                                      ) : null}
                                      {(checkflag = false)}
                                      <div
                                        class={
                                          question.type === "RadioBox" ||
                                          question.type === "CheckBox"
                                            ? "icon-wrapper"
                                            : null
                                        }
                                      >
                                        {question.type === "RadioBox" ||
                                        question.type === "CheckBox" ? (
                                          <Label
                                            for={possible_answers.id}
                                            label={
                                              <div
                                                contentEditable={Questionedit}
                                                spellcheck="false"
                                                data-gramm="false"
                                                onInput={handleAnswersInput({
                                                  ques_key: qai,
                                                  ans_key: pai,
                                                  quizdata: data,
                                                })}
                                                dangerouslySetInnerHTML={{
                                                  __html: `${
                                                    possible_answers.prompt_content
                                                      ? possible_answers.prompt_content.slice(
                                                          0,
                                                          OptIndex
                                                        )
                                                      : ""
                                                  } ${
                                                    possible_answers.image &&
                                                    !question.question_horizontal_display
                                                      ? `<img src=${possible_answers.image} height=${possible_answers.image_height}px/>`
                                                      : ""
                                                  }`,
                                                }}
                                              />
                                            }
                                          />
                                        ) : null}
                                        {possible_answers.is_correct === true &&
                                          isReview === true &&
                                          (question.type === "CheckBox" ||
                                            question.type === "RadioBox") &&
                                          isInUserSelectedAnswers(
                                            question,
                                            possible_answers.id
                                          ) && (
                                            <CorrectAnswer class="answer-badge bg-success" />
                                          )}

                                        {possible_answers.is_correct ===
                                          false &&
                                          isReview === true &&
                                          (question.type === "CheckBox" ||
                                            question.type === "RadioBox") &&
                                          isInUserSelectedAnswers(
                                            question,
                                            possible_answers.id
                                          ) && (
                                            <WrongAnswer class="answer-badge bg-danger" />
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    )}
                  </div>
                );
              } else {
                return null;
              }
            })}
          {data?.prompt_content?.isMounted &&
          data?.html_content?.isMounted &&
          IsGenerating &&
          window.location.pathname.includes(CreateQuizUrl) ? (
            <>
              {data?.q_type === "RadioBox" || data?.q_type === "CheckBox" ? (
                <ContentLoader
                  speed={1.5}
                  width={500}
                  height={200}
                  viewBox="0 0 500 200"
                  backgroundColor="#D9D9D9"
                  foregroundColor="#ebebeb"
                >
                  <rect x="5" y="10" rx="4" ry="4" width="300" height="31" />
                  <rect x="55" y="60" rx="4" ry="4" width="160" height="19" />
                  <circle cx="30" cy="70" r="10" />
                  <circle cx="30" cy="100" r="10" />
                  <circle cx="30" cy="130" r="10" />
                  <rect x="55" y="90" rx="4" ry="4" width="160" height="19" />
                  <rect x="55" y="120" rx="4" ry="4" width="160" height="19" />
                </ContentLoader>
              ) : data?.start_questions ? (
                <ContentLoader
                  speed={1.5}
                  width={500}
                  height={100}
                  viewBox="0 0 500 100"
                  backgroundColor="#D9D9D9"
                  foregroundColor="#ebebeb"
                >
                  <rect x="5" y="10" rx="4" ry="4" width="400" height="35" />
                </ContentLoader>
              ) : (
                <span className="blinking-cursor"></span>
              )}
            </>
          ) : (
            ""
          )}
          {task_type !== exerciseType.WRITING_TASK &&
          !(
            window.location.pathname.includes(GenaiUrl) ||
            window.location.pathname.includes(CreateQuizUrl)
          ) ? (
            <p className="quiz-bottom-border"></p>
          ) : null}
        </div>
      </div>
    );
  }
);

ShowExerciseQuestions.defaultProps = {
  questions: [],
  currentQuestion: 1,
  isReview: false,
};

ShowExerciseQuestions.propTypes = {
  questions: PropTypes.array.isRequired,
  onAnswer: PropTypes.func.isRequired,
  currentQuestion: PropTypes.number.isRequired,
  isReview: PropTypes.bool,
};
